<template>
  <div>
    <v-row>
      <v-col cols="4" offset="8" class="text-right">
        <v-text-field
          v-model="search"
          width="150"
          append-icon="mdi-magnify"
          dense
          rounded
          outlined
          hide-details
          placeholder="Search"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="businessCardHeaders"
          :items="cardholders"
          :items-per-page="8"
          :search="search"
          item-key="id"
        >
          <template v-slot:item.avatar="{ item }">
            <UserAvatar
              :key="`avatar${item.email}`"
              :usersInitials="item.firstName[0] + item.lastName[0]"
              :displayImageUrl="item.displayImageUrl || ''"
            />
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              label
              :color="
                getStatusColor(item.status) +
                '--text ' +
                getStatusColor(item.status) +
                ' lighten-5'
              "
              class="font-weight-medium text-capitalize"
              dark
              small
              >{{ item.status }}</v-chip
            >
          </template>
          <template v-slot:item.businessName="{ item }">
            <div>{{ item.businessName ? item.businessName : "-" }}</div>
          </template>
          <template v-slot:item.jobTitle="{ item }">
            <div>{{ item.jobTitle ? item.jobTitle : "-" }}</div>
          </template>
          <template v-slot:item.mcOptins="{ item }">
            <div>{{ getNoOfMCOptins(item) }}</div>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-menu transition="slide-y-transition" bottom left offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="handleAppAccountClick(item)">
                  <v-list-item-title>View App Account</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.subscriptionType != 'HATCH'"
                  @click="handleViewBusinessProfileClick(item)"
                >
                  <v-list-item-title>View Business Profile</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="getNoOfMCOptins(item) != 0"
                  @click="handleViewMCEventsClick(item)"
                >
                  <v-list-item-title>View MC Optins</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="
                    item.status === 'Active' && item.subscriptionType != 'HATCH'
                  "
                  @click="handleDeactivateBusinessCard(item)"
                >
                  <v-list-item-title>Deactivate</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="
                    item.status === 'Active' && item.subscriptionType == 'HATCH'
                  "
                  @click="handleDeleteBusinessCard(item)"
                >
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
                <v-list-item @click="handleEditBusinessCard(item)">
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <AppAccountDetails
      v-if="businessCard != null"
      :show="showDialog"
      :cardholders="cardholders"
      :businessPortalAccess="businessPortalAccess"
      :users="users"
      :uid="businessCard.uid"
      @close="showDialog = false"
    />
    <BusinessProfileDetails
      v-if="businessCard != null"
      :show="showBusinessProfileDetailsDialog"
      :businessCard="businessCard"
      :cardholders="cardholders"
      :businessProfiles="businessProfiles"
      :users="users"
      @close="showBusinessProfileDetailsDialog = false"
      :businessProfileId="businessCard.businessProfileId"
      :businessPortalAccess="businessPortalAccess"
    />

    <v-dialog
      v-model="showEventsDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card height="70%" flat tile>
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="showEventsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Multi Conenct Opt-In Details</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-sheet height="90%">
          <v-container class="fill-height align-start" fluid>
            <v-row align="start">
              <v-col
                cols="12"
                v-if="businessCard != null && businessCard != undefined"
              >
                <v-list color="transparent">
                  <v-list-item class="pl-0 pr-0">
                    <UserAvatar
                      :displayImageUrl="businessCard.logoImageURL"
                      :usersInitials="
                        businessCard.firstName[0] +
                        ' ' +
                        businessCard.lastName[0]
                      "
                    >
                    </UserAvatar>

                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium"
                        >{{
                          businessCard.firstName + " " + businessCard.lastName
                        }}
                        &ensp;
                      </v-list-item-title>
                      <v-list-item-subtitle
                        >{{ businessCard.email }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12">
                <MultiConnectTable
                  :multiConnectEvents="connectedMCEvents"
                  :isSuperUserDashboard="true"
                  :hideCreateNewEventButton="true"
                  :hideActionsMenu="true"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-card>
    </v-dialog>

    <DeactivateCardHolderDialog
      :show="showDeactivateCardHolderDialog"
      :businessCard="businessCard"
      @close="showDeactivateCardHolderDialog = false"
    />

    <ConfirmationDialog
      :show="showConfirmationDialog"
      title="Delete business card?"
      content="Are you sure you want to delete this business card? All information related to this business card will be deleted."
      @click="deleteBusinessCard"
      @closeDialog="showConfirmationDialog = false"
      buttonText="Delete"
    />

    <LoadingDialog
      :show="showLoadingDialog"
      title="Deleting business card..."
    />

    <AddEditCardHolderDialog
      :show="showAddEditCardHolderDialog"
      @close="showAddEditCardHolderDialog = false"
      :businessCard="businessCard"
    />
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import AppAccountDetails from "@/components/SuperUser/AppAccountDetails";
import BusinessProfileDetails from "@/components/SuperUser/BusinessProfileDetails";
import MultiConnectTable from "@/components/MultiConnect/MultiConnectTable";
import DeactivateCardHolderDialog from "@/components/CardHolders/DeactivateCardHolderDialog";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import LoadingDialog from "@/components/LoadingDialog";
import AddEditCardHolderDialog from "@/components/CardHolders/AddEditCardHolderDialog";
import {deleteBusinessCardsDoc} from "@/shared/firebase_utils";

export default {
  props: {
    cardholders: {
      type: Array,
      default: function () {
        return [];
      },
    },
    businessPortalAccess: {
      type: Array,
      default: function () {
        return [];
      },
    },
    users: {
      type: Array,
      default: function () {
        return [];
      },
    },
    businessProfiles: {
      type: Array,
      default: function () {
        return [];
      },
    },
    allMultiConnectEvents: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    UserAvatar,
    AppAccountDetails,
    BusinessProfileDetails,
    MultiConnectTable,
    DeactivateCardHolderDialog,
    ConfirmationDialog,
    LoadingDialog,
    AddEditCardHolderDialog,
  },
  data() {
    return {
      businessCardHeaders: [
        {
          text: "",
          align: "right",
          value: "avatar",
          sortable: false,
        },
        {
          text: "First Name",
          align: "left",
          value: "firstName",
        },
        {
          text: "Last Name",
          align: "left",
          value: "lastName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Business Name",
          align: "left",
          value: "businessName",
        },
        {
          text: "Job Title",
          align: "left",
          value: "jobTitle",
        },
        {
          text: "Subscription type",
          align: "left",
          value: "subscriptionType",
        },
        {
          text: "Status",
          align: "left",
          value: "status",
        },
        {
          text: "MC Opt-Ins",
          align: "left",
          value: "mcOptins",
        },
        {
          text: "Actions",
          align: "left",
          value: "actions",
        },
      ],
      search: "",
      businessCard: null,
      showDialog: false,
      showBusinessProfileDetailsDialog: false,
      connectedMCEvents: [],
      showEventsDialog: false,
      showDeactivateCardHolderDialog: false,
      showConfirmationDialog: false,
      showLoadingDialog: false,
      showAddEditCardHolderDialog: false,
    };
  },
  methods: {
    getStatusColor(status) {
      if (status) {
        if (
          status.toLowerCase() == "active" ||
          status.toLowerCase() == "trialing"
        )
          return "green";
        else if (status.toLowerCase() == "pending") return "orange";
        else if (status.toLowerCase() == "declined") return "red";
        else return "red";
      }
    },
    handleAppAccountClick(businessCard) {
      this.businessCard = businessCard;
      this.showDialog = true;
    },
    handleViewBusinessProfileClick(businessCard) {
      this.businessCard = businessCard;
      this.showBusinessProfileDetailsDialog = true;
    },
    getNoOfMCOptins(businessCard) {
      if (
        businessCard.connectedEventIds != undefined &&
        businessCard.connectedEventIds.length > 0
      ) {
        let multiConnectEvents = businessCard.connectedEventIds.filter(
          (eventId) => {
            return this.allMultiConnectEvents.some((event) => {
              return event.id == eventId;
            });
          }
        );

        return multiConnectEvents.length;
      } else {
        return 0;
      }
    },
    handleViewMCEventsClick(businessCard) {
      this.businessCard = businessCard;
      this.connectedMCEvents = this.allMultiConnectEvents.filter((mcEvent) => {
        return businessCard.connectedEventIds.find((eventId) => {
          return eventId == mcEvent.id;
        });
      });

      this.showEventsDialog = true;
    },
    handleDeactivateBusinessCard(businessCard) {
      this.businessCard = businessCard;
      this.showDeactivateCardHolderDialog = true;
    },
    handleDeleteBusinessCard(businessCard) {
      this.businessCard = businessCard;

      this.showConfirmationDialog = true;
    },
    async deleteBusinessCard() {
      try {
        this.showConfirmationDialog = false;
        this.showLoadingDialog = true;

        await deleteBusinessCardsDoc(this.businessCard.id);
        this.showLoadingDialog = false;
        this.showSnackbar({ show: true, text: "Deleted Successfully!" });
      } catch (error) {
        console.log("Error occurred while deleting businesss card: ", error);
      }
    },
    handleEditBusinessCard(businessCard) {
      this.businessCard = businessCard;
      this.showAddEditCardHolderDialog = true;
    },
  },
};
</script>

<style></style>
